var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8118 0C11.4946 0 11.1967 0.116237 10.9732 0.326876L4.63805 6.29866L2.02714 3.83751C1.80297 3.62486 1.50432 3.50795 1.18713 3.50795C0.869945 3.50795 0.571292 3.62486 0.347479 3.83718C0.123311 4.04815 0 4.329 0 4.628C0 4.92699 0.123311 5.20784 0.346766 5.41848L3.79946 8.67313C4.02327 8.88376 4.32086 9 4.63805 9C4.95523 9 5.25317 8.88376 5.47663 8.67313L12.6507 1.91053C12.8767 1.69754 13.0007 1.41534 13.0004 1.11601C13 0.818029 12.876 0.53785 12.6511 0.327212C12.4269 0.116237 12.1293 0 11.8118 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.a3643f72d929fb7eaf25c22ffd832514.svg";
export { ForwardRef as ReactComponent };